import { createAction } from '@ngrx/store';

export const openShortcutsModal = createAction('[AppCommon] Open shortcuts modal');
export const closeShortcutsModal = createAction('[AppCommon] Close shortcuts modal');
